<template>

 <router-link　class="back" :to="to"><i class="fas fa-chevron-left"></i><ruby><rb>戻</rb><rt>もどる</rt></ruby>る</router-link>
</template>

<script>
export default {
  name: "t-back-button",
  props: ["to"],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../assets/style/common.scss";
.back {
  padding-left: 5px;
  text-align: left;
  display: inline-block;
  font-size: 20px;
  text-decoration: none;
  margin-bottom: 8px;
  color:#333333;

    // -文字を選択させない
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;

  & > ruby > rt {
    font-size: 12px;
  }

  @include mq-down(md) { 
    font-size: 18px;

    & > ruby > rt {
        font-size: 10px;
    }
    
  }

  & > i {
    margin-right: 8px;
  }
  &:hover {
    color: coral;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/atoms/TBackButton.vue